import { CUSTOMER_EXTERNAL_REFERENCE_KEY } from "../constants.js";
export const getCustomerDDSId = (customer) => {
    return customer?.externalReferences?.find((ref) => ref.key === CUSTOMER_EXTERNAL_REFERENCE_KEY.DDS_ID)?.value;
};
